<script setup>

const props = defineProps({
    letters: Object
});

const {prefix} = useLocaleStore();
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

import { useRouter } from 'nuxt/app';

const router = useRouter();

const scrollToLetter = (letterName) => {
    const elementId = `letter_${letterName}`;
    const element = document.getElementById(elementId);

    if (element && process.client) {
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: elementPosition - 50, //offset for mobile search
            behavior: 'instant',
        });
    } else {
        const basePath = `/${prefix}/${t('glossary')}/`;
        router.replace(basePath).then(() => setTimeout(() => scrollToLetter(letterName), 0));
    }
};
</script>

<template>
    <div class="alphabet">
        <template v-for="letter in letters" :key="letter.name">
            <a
                v-if="letter.data && letter.data.length"
                href="#"
                @click.prevent="scrollToLetter(letter.name)"
            >
                {{ letter.name }}
            </a>
            <span v-else>{{ letter.name }}</span>
        </template>
    </div>
</template>
